function Section({ title, text, children }) {
  return (
    <section className="section-border border-primary">
      <div className="container d-flex flex-column">
        <div className="row align-items-center justify-content-center gx-0 min-vh-100">
          <div className="col-12 col-md-5 col-lg-4 order-md-1 mb-auto mb-md-0 pb-8 py-md-11 mt-8">
            <div className="text-center mb-3">
              <i className="fe fe-alert-triiangle text-danger display-3"></i>
            </div>
            <h1 className="mb-0 fw-bold text-center text-primary">{title}</h1>
            <p className="mb-6 text-center text-muted">{text}</p>

            {children ?? null}
          </div>
        </div>
      </div>
    </section>
  );
}

export default Section;
